module.exports = __webpack_public_path__ + "static/boy-aa50fd6c71030e387b98a5b23d5de459.svg";